module.exports = __webpack_public_path__ + "static/img/1.2f41f5e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/99/zh/1.png
// module id = Ikqy
// module chunks = 0